// CSS
import '../scss/app.scss';

// JS
import * as bootstrap from 'bootstrap';
import { initAjaxForm } from './ajax';
import { initAjaxLink } from './ajax';
import { initBoxLink } from './box-link';
import { initCookieNotice } from './cookies';
import './breakpoint';

// Ajax form
initAjaxForm();

// Ajax link
initAjaxLink();

// Box link
initBoxLink();

// Cookie notice
initCookieNotice();

// global, shared javascript
$(document).ajaxSend(function (event, request, settings) {
  // add ajax class only when request is not resolved quickly (to show loading effect)
  setTimeout(function () {
    if (request.readyState != 4) {
      $('body').addClass('ajax');
    }
  }, 300);
  // setting headers
  let csrfToken = document
    .querySelector('meta[name="X-CSRF-Token"]')
    .getAttribute('content');
  request.setRequestHeader('X-CSRF-Token', csrfToken);
});
$(document).ajaxComplete(function (event, request, settings) {
  $('body').removeClass('ajax');
});

// custom
$(function () {
  $(document).on('click', '.has-subnav:not(".disable-submenu") > a', function (e) {
    e.preventDefault();
    $('> ul', $(this).parents('.has-subnav')).toggle();
  });

  $(document).on('click', '.navbar-toggler', function (e) {
    $('.icon-close, .icon-menu', this)
      .toggleClass('icon-close')
      .toggleClass('icon-menu');
  });

  $(document).on('click', '.breadcrumbs li:first-child a', function (e) {
    e.preventDefault();
    var mainMenuCollapse = document.getElementById('mainMenu');
    var bsCollapse = new bootstrap.Collapse(mainMenuCollapse);
    $('.icon-close, .icon-menu', '.navbar-toggler')
      .toggleClass('icon-close')
      .toggleClass('icon-menu');
  });
  $(document).on('click', '.breadcrumbs li:last-child a', function (e) {
    e.preventDefault();
  });
});
